import { Component, Input, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DsButtonVariants, DsModule } from '@levelaccess/design-system';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

import { SharedTenantsModule } from '../../../../admin/tenants/shared-tenants.module';
import { AppConfigService } from '../../../../services/app-config.service';
import { CommonPipesModule } from '../../../../shared/common-pipes.module';
import { IDigitalPropertyDetails } from '../../../../../../shared/interfaces/digital-property.interface';
import { EditDigitalPropertyComponent } from '../../portfolio/edit-digital-property/edit-digital-property.component';
import { FeatureFlagService } from '../../../../services/feature-flag/feature-flag.service';
import { FeatureFlagCollection } from '../../../../../../shared/interfaces/feature-flag.interface';

@Component({
  selector: 'app-edit-digital-property-modal',
  templateUrl: './edit-digital-property-modal.component.html',
  styleUrl: './edit-digital-property-modal.component.scss',
  imports: [CommonModule, DsModule, CommonPipesModule, SharedTenantsModule, EditDigitalPropertyComponent],
})
export class EditDigitalPropertyModalComponent {
  public readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  @Input() workspaceId: string;
  @Input() digitalPropertyId: string;
  @Input() isWebsite: boolean;

  public readonly isAdminView: boolean;
  public readonly digitalAssetFormUpdateEnabled: Signal<boolean> = toSignal(
    this.featureFlagService.variation$(FeatureFlagCollection.digitalAssetFormUpdate, false).pipe(map(Boolean)),
    { initialValue: false },
  );

  constructor(
    public modal: NgbActiveModal,
    private appConfigService: AppConfigService,
    private featureFlagService: FeatureFlagService,
  ) {
    this.isAdminView = this.appConfigService.isTenantEnabled() === false;
  }

  onDigitalPropertyEdited(editedDigitalProperty: IDigitalPropertyDetails): void {
    this.modal.close(editedDigitalProperty);
  }

  onCancel(): void {
    this.modal.dismiss();
  }
}
